<template>
  <div class="acquirer">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet class="my-4">
          <!-- <v-breadcrumbs :items="['Network Configuration']"></v-breadcrumbs>  -->
          <v-breadcrumbs :items="[ { text: $t('network_config'), disabled: true, href: '/' } ]"></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet class="ma-2 pa-2">
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_network") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    
        <v-row>
          <v-col cols="3" class="mb-4">
          <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
        </v-col>
        </v-row>

        <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
      ></v-progress-circular>

    <v-card v-else>
      <v-spacer></v-spacer>

      <v-data-table
        :headers="headers"
        :items="network"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.value.networkId)" v-if="this.global_permissions.includes('NETWORK_EDIT')">mdi-pencil</v-icon>
            <v-icon color="red" small @click="compose_delete(item.value.networkId)" v-if="this.global_permissions.includes('NETWORK_DELETE')">mdi-delete</v-icon> -->
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="green"
                small
                class="mr-2"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_USER_ADMIN') ||
                  this.global_permissions.includes('ROLE_USER_ASSIST')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_USER_ADMIN') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>
        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="pageCount < 3 ? 3 : 7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD NETWORK DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">
                {{ $t('add_network') }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('network_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="network_data.f_networkName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      :label="$t('primary_ip')"
                      :readonly="loading"
                      :rules="[required, validateIP]"
                      clearable
                      v-model="network_data.f_primaryIp"
                    ></v-text-field>
                  </v-col>
                  <v-col ccols="6" sm="6">
                    <v-text-field
                      :label="$t('primary_port')"
                      :readonly="loading"
                      :rules="[required, validatePort]"
                      clearable
                      v-model="network_data.f_primaryPort"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      :label="$t('secondary_ip')"
                      :rules="[required, validateIP]"
                      clearable
                      v-model="network_data.f_secondaryIp"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      :label="$t('secondary_port')"
                      :rules="[required, validatePort]"
                      v-model="network_data.f_secondaryPort"
                    ></v-text-field>
                  </v-col>
                  <v-col ccols="6" sm="6">
                    <v-text-field
                      label="NII"
                      :rules="[required, validateNii]"
                      v-model="network_data.f_nii"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="acquirers"
                      item-title="acquirerName"
                      item-value="acquirerId"
                      :label="$t('select_acquirer')"
                      v-model="network_data.f_acquirerId"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">                                 
                      <v-select
                        :items= "organization"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select Organization*"                          
                        required
                        v-model="network_data.f_orgId"
                      ></v-select>                                              
                    </v-col>                      -->
                </v-row>
              </v-container>
              <small>* {{ $t('indicateRequires') }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{ $t('Close') }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addNetwork"
                >{{ $t('Save') }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE NETWORK DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t('update_network') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('network_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="network_data.f_networkName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      :label="$t('primary_ip')"
                      :readonly="loading"
                      :rules="[required, validateIP]"
                      clearable
                      v-model="network_data.f_primaryIp"
                    ></v-text-field>
                  </v-col>
                  <v-col ccols="6" sm="6">
                    <v-text-field
                      :label="$t('primary_port')"
                      :readonly="loading"
                      :rules="[required, validatePort]"
                      clearable
                      v-model="network_data.f_primaryPort"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      :label="$t('secondary_ip')"
                      :rules="[required, validateIP]"
                      v-model="network_data.f_secondaryIp"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                       :label="$t('secondary_port')"
                      :rules="[required, validatePort]"
                      v-model="network_data.f_secondaryPort"
                    ></v-text-field>
                  </v-col>
                  <v-col ccols="6" sm="6">
                    <v-text-field
                      label="NII"
                      :rules="[required, validateNii]"
                      v-model="network_data.f_nii"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="acquirers"
                      item-title="acquirerName"
                      item-value="acquirerId"
                      :label="$t('select_acquirer')"
                      v-model="network_data.f_acquirerId"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">                                 
                      <v-select
                        :items= "organization"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select Organization*"                          
                        required
                        v-model="network_data.f_orgId"
                      ></v-select>                                              
                    </v-col>                 -->
                </v-row>
              </v-container>
              <small>*{{ $t('indicateRequires') }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{ $t('Close') }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateNetwork"
                >{{ $t('Update') }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE ACQUIRER DIALOG -->

    <!-- DELETE NETWORK DIALOG -->
    <!-- <v-dialog
            v-model="dialog_delete"
            persistent
            width="500"
          >              
            <v-card>
              <v-card-title>
                <span class="text-h5">do you want to delete?</span>
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false" > Close</v-btn>                  
                <v-btn color="blue-darken-1" variant="text" @click="deleteNetwork">Delete</v-btn>                 
              </v-card-actions>
            </v-card>
          </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t('deleteFile') }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t('deleteText') }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteNetwork">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE ACQUIRER DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Acquirer",
  props: {
    msg: String,
  },

  data() {
    return {
      name: "",
      network: [], //used
      acquirers: [], //used
      //organization: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      network_data: {
        //used
        f_networkName: "",
        f_primaryIp: "",
        f_primaryPort: "",
        f_secondaryIp: "",
        f_secondaryPort: "",
        f_nii: "",
        f_acquirerId: "",
        //f_orgId: '',
      },

      networkId: "",

      search: "",
      headers: [
        {
          title: this.$t("name"),
          align: "start",
          sortable: false,
          key: "networkName",
        },
        { title: this.$t("primary_ip"), key: "primaryIp" },
        { title: this.$t("primary_port"), key: "primaryPort" },
        { title: this.$t("secondary_ip"), key: "secondaryIp" },
        { title: this.$t("secondary_port"), key: "secondaryPort" },
        { title: "NII", key: "nii" },
        { title: this.$t("Acquirer name"), key: "acquirer.acquirerName" },
        //{ title: 'Organization', key: 'acquirer.organization.orgName' },
        { title: this.$t("Actions"), key: "actions", sortable: false, width: "100px" },
      ],

      //form
      form: false,
      loading: true,
      email_exist: false,

      //FOR USER DATA
      user_roles: "",
      user_org: "",
      user_permissions: [],

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    //auto-complete
    search(newSearch) {
      if (newSearch.length >= 2) {
        this.searchCountry(newSearch);
      } else {
        this.countries = [];
      }
    },
  },

  created() {
    //this.initialize()
  },

  methods: {
    // initialize () {
    //   this.acquirer

    // },

    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.network_data.f_networkName = "";
      this.network_data.f_primaryIp = "";
      this.network_data.f_primaryPort = "";
      this.network_data.f_secondaryIp = "";
      this.network_data.f_secondaryPort = "";
      this.network_data.f_nii = "";
      this.network_data.f_acquirerId = "";
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.networkId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.networkId = id;
      this.dialog_delete = true;
    },

    requests_handler() {
      //second method
      axios
        .all([
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get("http://localhost:8080/api/org/get/4cb06b44-f37c-463b-9d69-ef7fe3ba7618")
        ])
        .then(
          axios.spread((acquirer_response) => {
            //console.log("data2", acquirer_response.data);
            //console.log("data3", org_response.data)

            //if response data is an array // handle it as below
            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    acquirerId: acquirer_response.data.records[i].id,
                    acquirerName:
                      acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("countries", this.acquirers)
                }
              }
            }

            // if(org_response.status == 200){
            //     this.organization = [];   //remove all items from array
            //     this.organization.push(org_response.data);

            // }
          })
        );
    }, //end of requests_handler method

    async addNetwork() {
      //this.dialog = false
      //console.log("form data", this.network_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "hostParams",
          {
            networkName: this.network_data.f_networkName,
            primaryIp: this.network_data.f_primaryIp,
            primaryPort: this.network_data.f_primaryPort,
            secondaryIp: this.network_data.f_secondaryIp,
            secondaryPort: this.network_data.f_secondaryPort,
            acquirer_id: this.network_data.f_acquirerId,
            nii: this.network_data.f_nii,
            //orgId:this.network_data.f_orgId,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("log in successfull");
          //this.show_toast(true, "success", "Successful");
          this.$root.vtoast.show({ message: this.$t("network_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
          //this.$router.go();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.response.data.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "hostParams/" + this.networkId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((network_response, acquirer_response) => {
            // console.log("data1", network_response.data);
            // console.log("data2", acquirer_response.data);
            //console.log("data3", org_response.data)

            //get acquirer data for selected id and display data in for dialog
            if (network_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("network Data", network_response);
              this.network_data.f_networkName =
                network_response.data.networkName;
              this.network_data.f_primaryIp = network_response.data.primaryIp;
              this.network_data.f_primaryPort =
                network_response.data.primaryPort;
              this.network_data.f_secondaryIp =
                network_response.data.secondaryIp;
              this.network_data.f_secondaryPort =
                network_response.data.secondaryPort;
              this.network_data.f_acquirerId =
                network_response.data.acquirer.id;
              this.network_data.f_nii = network_response.data.nii;
              //this.network_data.f_orgId = network_response.data.acquirer.organization.id
            }

            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    acquirerId: acquirer_response.data.records[i].id,
                    acquirerName:
                      acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("countries", this.acquirers)
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateNetwork() {
      //this.dialog_update = false
      this.checkTokenExpiry();
      // console.log("update form network id", this.networkId);
      // console.log("update form network", this.network_data);
      try {
        let result = await axios.put(
          window.baseurl + "hostParams/" + this.networkId,
          {
            networkName: this.network_data.f_networkName,
            primaryIp: this.network_data.f_primaryIp,
            primaryPort: this.network_data.f_primaryPort,
            secondaryIp: this.network_data.f_secondaryIp,
            secondaryPort: this.network_data.f_secondaryPort,
            acquirer_id: this.network_data.f_acquirerId,
            nii: this.network_data.f_nii,
            //orgId:this.network_data.f_orgId,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.log("update form country result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          this.$root.vtoast.show({ message: this.$t("network_updated") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
          //this.$router.go();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        //console.log("error", error);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteNetwork() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "hostParams/" + this.networkId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.log("update form acquirer result", result)
        if (result.status == 204) {
          //alert("successfull deleted");
          //this.show_toast(true, "success", "Deleted");
          this.$root.vtoast.show({ message: this.$t("network_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
          //this.$router.go();
        }
      } catch (error) {
        this.$root.vtoast.showError({ message: error.response.data.error });
      }
    },

    async fetchData() {
      let result;
      this.loading = true;
      let page2 = this.page - 1;

      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "hostParams", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("network_object", result);
          this.network = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "hostParams/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("network_object", result);
          this.network = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchData() {
      //console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
        this.global_permissions.includes("ROLE_STAFF_USER")) {
          result = await axios.get(window.baseurl + "hostParams/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          //console.log("hostParams_object", result);
          this.network = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;

          this.loading = false;
        }
        if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "hostParams/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );
          //console.log("hostParams_object", result);
          this.network = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;

          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },


    // async searchData() {
    //   console.log("in searchData", this.query);
    //   this.checkTokenExpiry();
    //   let result;
    //   this.loading = true;
    //   let page2 = this.page - 1;
    //   try {
    //     if (this.global_permissions.includes("ROLE_STAFF_ADMIN")) {
    //       result = await axios.get(window.baseurl + "hostParams/search", {
    //         params: { page: page2, search: this.query },
    //         headers: { Authorization: "Bearer " + this.accessToken },
    //       });

    //       console.log("acquirer_object", result);
    //       this.network = result.data.records;
    //       this.totalItems = result.data.totalRecords;
    //       this.itemsPerPage = result.data.pageSize;
    //       this.totalPages = result.data.totalPages;

    //       this.loading = false;
    //     }
    //     if (
    //       this.global_permissions.includes("ROLE_USER_ADMIN") ||
    //       this.global_permissions.includes("ROLE_USER_ASSIST")
    //     ) {
    //       result = await axios.get(
    //         window.baseurl + "hostParams/org/search/" + this.orgId,
    //         {
    //           params: { page: page2, search: this.query },
    //           headers: { Authorization: "Bearer " + this.accessToken },
    //         }
    //       );
    //       console.log("network_object", result);

    //       this.network = result.data.records;
    //       this.totalItems = result.data.totalRecords;
    //       this.itemsPerPage = result.data.pageSize;
    //       this.totalPages = result.data.totalPages;

    //       this.loading = false;
    //     }
    //   } catch (error) {
    //     //this.show_toast(true, "warning", error.message);
    //     this.$root.vtoast.showError({ message: error.message });
    //     this.loading = false;
    //   }
    // },

    /*RULES VALIDATION */

    validateName(value) {
      const regex = /^[A-Za-z0-9_. ]+$/;
      return (
        regex.test(value) ||
        "Name can only be numbers, characters, space, underscore and ."
      );
    },
    validatePort(value) {
      const regex = /^[0-9]{4}$/;
      return (
        regex.test(value) || "Port can only be 4 characters long and numbers."
      );
    },
    validateNii(value) {
      const regex = /^[0-9]{3}$/;
      return (
        regex.test(value) || "NII can only be 3 characters long and numbers."
      );
    },
    validateIP(value) {
      const regex = /^([0-9]{1,3}\.){3}[0-9]{1,3}$/;
      return (
        regex.test(value) ||
        "Invalid IP address format. Please enter a valid IP address."
      );
    },
  },
  //get list of networks config  $BASE_URL
  async mounted() {
    this.checkTokenExpiry();

    //fetch data
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
